module.exports = "/_next/static/images/store-bitcoin-ecb92f35381ad405d69f019cdbcb98a6.png";